<mat-icon
  *ngIf="!useFallback; else fallbackIcon"
  [class]="svgIconClass"
  [class.rotated]="rotated"
  [svgIcon]="svgIcon"
  aria-hidden="false"
></mat-icon>

<ng-template #fallbackIcon>
  <mat-icon
    [class]="svgIconClass"
    aria-hidden="false"
  >{{ svgIcon }}</mat-icon>
</ng-template>
